import Vue from 'vue';

const TableEventBus = new Vue();
export default TableEventBus;


